<template>
  <smd-one-col-layout class="view-files-all"
                      :content-styles="contentStylesClass">
    <smd-search class="m-t-15"
                placeholder="Search all files"
                slot="toolbar"
                v-model="search"
                v-if="$isMobile"/>


    <smd-search class="m-b-50"
                placeholder="Search all files"
                v-model="search"
                v-else/>

    <div class="cover" v-if="!filteredFiles.length">
      <empty-state type="recordsAll" :variant="search !== '' ? 'filter' : 'empty'"/>
    </div>
    <template v-else>
      <component v-for="(file, fileIndex) in filteredFiles"
                :key="fileIndex"
                :is="getFileComponent(file)"
                :file-data="file"/>
    </template>
  </smd-one-col-layout>
</template>

<script>
  import FilesMixin from '../files-mixin';
  import {mapGetters} from "vuex";
  import {GETTER_FILES_FROM_DOC} from "@/store/types";

  export default {
    name: 'view-files-all',
    mixins: [FilesMixin],
    computed: {
      ...mapGetters({
        files: GETTER_FILES_FROM_DOC,
      }),
      contentStylesClass() {
        return [{'dark-light-bg': !this.$isMobile}, 'view-files-all__content']
      }
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .view-files-all__content {
    > div {
      @include set-max-width($max-width: 1583px);
    }

    @include responsive('min-width: 1024px') {
      padding: space(xxl) !important;

      .smd-form--search {
        max-width: 792px;
      }
    }
  }
</style>